import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";

import { debounce } from "./functions";

export const isTouchDevice = "ontouchstart" in document.documentElement;
export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
export const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
export const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const inner = {
    w: window.innerWidth,
    h: window.innerHeight,
};

let customPropertyMeasurementEl: HTMLDivElement | null = null;

export let varGutter: number = 0;
export let varGap: number = 0;
export let headerHeight: number = 0;

export function calcResize(triggerScrollRefresh: boolean = true) {
    inner.w = window.innerWidth;
    inner.h = window.innerHeight;

    varGutter = convertMaxProp("--gutter");
    varGap = convertMaxProp("--gap");

    calcHeaderHeight();

    if (triggerScrollRefresh) ScrollTrigger.refresh();
}

export function calcHeaderHeight() {
    const header = document.querySelector<HTMLElement>(".header");

    if (!header) {
        headerHeight = 0;
        return 0;
    }

    headerHeight = header.offsetHeight;
    gsap.set(":root", { "--header-height": headerHeight + "px" });

    return headerHeight;
}

function convertMaxProp(maxProp: string) {
    const measurementEl = getCustomPropertyMeasurementEl();

    measurementEl.style.width = `var(${maxProp})`;

    const resolvedValue = parseFloat(getComputedStyle(measurementEl).width);

    return Number.isNaN(resolvedValue) ? 0 : resolvedValue;
}

function getCustomPropertyMeasurementEl() {
    if (customPropertyMeasurementEl) return customPropertyMeasurementEl;

    customPropertyMeasurementEl = document.createElement("div");
    customPropertyMeasurementEl.setAttribute("aria-hidden", "true");
    customPropertyMeasurementEl.style.position = "absolute";
    customPropertyMeasurementEl.style.visibility = "hidden";
    customPropertyMeasurementEl.style.pointerEvents = "none";
    customPropertyMeasurementEl.style.inlineSize = "0";
    customPropertyMeasurementEl.style.blockSize = "0";
    customPropertyMeasurementEl.style.overflow = "hidden";
    customPropertyMeasurementEl.style.inset = "0";

    (document.body ?? document.documentElement).appendChild(customPropertyMeasurementEl);

    return customPropertyMeasurementEl;
}

function resize() {
    if (isTouchDevice) {
        const isSignificantResize = window.innerHeight > inner.h + inner.h * 0.3 || window.innerHeight < inner.h - inner.h * 0.3;
        if (isSignificantResize) calcResize();
    } else calcResize(true);
}

export function initVariables() {
    calcResize(false);
    const debouncedResize = debounce(resize, 300);
    window.addEventListener("resize", debouncedResize);
}
